import { useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useClient, useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import query from './query.graphql.js'
import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let charge_ids = useDataValue({
    context: 'selected',
    path: 'charge_ids',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let client = useClient()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let response = await client
      .query(query, { location_ids: args.location_ids, charge_ids })
      .toPromise()
    let objects = response.data.vaxiom_sys_organizations.flatMap(organization =>
      response.data.vaxiom_misc_fee_charge_templates.map(charge => ({
        name: charge.name,
        price: charge.price,
        insurance_code_id: charge.insurance_code_id,
        affecting_production_report: charge.affecting_production_report,
        is_included_in_insurance_claim: charge.is_included_in_insurance_claim,
        organization_id: organization.id,
      }))
    )
    let mutationResponse = await executeMutation({
      objects,
    })
    if (mutationResponse.error) {
      notify(notifyError('An error has occurred while copying charges.'))
      return
    }

    notify(notifySuccess('Charge has been copied to target locations.'))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
